import React from 'react';
import { Col, Row } from 'antd';
import Stripe from './Stripe';
import Cards from './Cards';
import planImage from '../../assets/images/bitmap.png';
import logo from '../../assets/images/logo-dark.svg';
import Loader from '../../components/Loader';
import { get } from '../../services/providers/settings/payment_card';

class CheckoutForm extends React.Component {
  state = {
    loading: true,
    addCardMode: false,
  };

  async componentDidMount() {
    let cards = [];
    try {
      const { results } = await get();
      cards = results;
    } catch (e) {

    }

    this.setState({
      cards: cards,
      addCardMode: cards.length ? true : false,
      loading: false,
    });
  }

  onAddNewCard = () => {
    this.setState({ addCardMode: false });
  };

  render() {
    const { loading, addCardMode, cards } = this.state;

    if (loading) {
      return <Loader tip="" />;
    }

    return (
      <div className="AppWrapper">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>
        <h1 className="h1 mb-4">Subscriptions</h1>
        <div className="AppContentWrapper">
          <Row>
            <Col span={14} className="gutter-row border-right">
              <h2 className="h2">Payment</h2>
              <div className="gutter-box">
                {addCardMode
                  ? <Cards paymentCards={cards} onAddNewCard={this.onAddNewCard} />
                  : <Stripe />}
              </div>
            </Col>
            <Col span={10} className="gutter-row">
              <h2 className="h2">Order Summary</h2>
              <div className="gutter-box text-center">
                <img src={planImage} />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default CheckoutForm;




// WEBPACK FOOTER //
// ./src/containers/Subscriptions/index.js